import React from 'react';
import SignIn from './app/components/auth/SignIn';
import Header from './app/components/header/Menu';
import ManageUsers from "./app/components/users/ManageUsers";
import ManageIssues from "./app/components/issues/ManageIssues"
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import Dashboard from './app/components/Dashboard/Dashboard';
import { styled } from '@mui/material/styles';
import './App.css';
import Layout from './app/components/layout/Layout';
import RequireAuth from './app/components/auth/RequireAuth';
import ManageClients from './app/components/clients/ManageClients';
import Profile from './app/components/issues/Profile';
import ForgotPassword from './app/components/auth/ForgotPassword';
import LoginLayout from './app/components/layout/LoginLayout';
import ReviewTask from './app/components/review/ReviewTask';
import ClientApp from './app/components/clients/ClientApp';


const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    //marginLeft: `-${drawerWidth}px`,
    marginLeft: 65,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: `${drawerWidth}px`,
    }),
  }),
);

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

const MainContent = () => {
  //const [open, setOpen] = React.useState(true);
  //const { instance, accounts } = useMsal();
  // const tokenReq = {
  //   scopes: ["api://d79602d3-9090-46e7-a9fc-9aa338a4f519/readWrite"],
  //   account: accounts[0]
  // }
  // var token = instance.acquireTokenSilent(tokenReq).then(accessTokenn => {
  //   let tk = accessTokenn.accessToken;
  //   console.log(tk);
  // })
  return (
    <>
      {/* <AuthenticatedTemplate>
        <Header open={open} setOpen={setOpen} />
        <Main open={open}>
          <DrawerHeader />
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="users" element={<ManageUsers />} />
            <Route path="issues" element={<ManageIssues />} />
          </Routes>
        </Main>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Routes>
          <Route path="/" element={<SignIn />} />
        </Routes>
      </UnauthenticatedTemplate> */}

      <Routes>
        <Route element={<LoginLayout />}>
          <Route path="login" element={<SignIn />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
        </Route>
        <Route element={<RequireAuth />}>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="profile" element={<Profile />} />
            <Route path="users" element={<ManageUsers />} />
            <Route path="issues" element={<ManageIssues />} />
            <Route path="clients" element={<ManageClients />} />
            <Route path="review" element={<ReviewTask />} />
            <Route path="clientApp" element={<ClientApp />} />
          </Route>
        </Route>
      </Routes >
    </>
  );
};

function App() {
  return (
    <MainContent />
  );
}

export default App;
